const ManageSubscription = {
  getAllSubscription: {
    url: "/subscription",
    method: "GET",
  },
  getAdminSubscription: {
    url: "/admin/subscription",
    method: "GET",
  },
  updateSubscription: (id) => ({
    url: `/subscription/${id}`,
    method: "PUT",
  }),
  getAllPackage: {
    url: "/package",
    method: "GET",
  },
  updatePackage: (id) => ({
    url: `/package/${id}`,
    method: "PUT",
  }),
  updatePackageStatus: (id) => ({
    url: `/package/${id}`,
    method: "PATCH",
  }),
  updatePayment: (id) => ({
    url: `/subscription/payment-status/${id}`,
    method: "PUT",
  }),
  updateSubscriptionStatus: (id) => ({
    url: `/subscription/${id}`,
    method: "PATCH",
  }),
};

export default ManageSubscription;
